<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
<div mat-dialog-title class="matDialogTitle" style="direction:rtl">
  <span> {{ title }} </span>
  <span class="close" (click)="close()" ><mat-icon>close</mat-icon></span>
</div>

 
<div mat-dialog-content class="matDialogContent" style="overflow-y: hidden;font-size: 1.4rem !important;width: 100rem;direction: ltr;padding: 0rem !important;"> 
  <form class="example-form">
      <textarea matInput style="width:100%;" spellcheck="false" name="codes" [(ngModel)]="codes">{{ codes }}</textarea>
  </form>
</div>

<div class="matDialogActions" mat-dialog-actions align="end" class="pe1" [ngClass]="{en1:lang==2}" style="margin-bottom: 0px !important;">
 <button class="btn btn1" (click)="update()">
    <span *ngIf="lang==1">Save</span>
    <span *ngIf="lang==2">ذخیره</span>
 </button>
</div>